import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
export var ClassStudentProgressRepository = /*#__PURE__*/function () {
  function ClassStudentProgressRepository(api) {
    _classCallCheck(this, ClassStudentProgressRepository);

    this.api = api;
  }

  _createClass(ClassStudentProgressRepository, [{
    key: "getTeacherOverview",
    value: function getTeacherOverview(classId) {
      return this.api.getTeacherOverview(classId);
    }
  }, {
    key: "listSubmissions",
    value: function listSubmissions(input) {
      return this.api.listSubmissions(input);
    }
  }, {
    key: "getStudent",
    value: function getStudent(input) {
      return this.api.getStudent(input);
    }
  }, {
    key: "getOverview",
    value: function getOverview(input) {
      return this.api.getOverview(input);
    }
  }, {
    key: "listAssignments",
    value: function listAssignments(input) {
      return this.api.listAssignments(input);
    }
  }]);

  return ClassStudentProgressRepository;
}();